<template>
  <div>
    <div class="subheading font-weight-medium">
      <v-icon>place</v-icon>
      Address
    </div>

    <v-text-field
    v-model="formData.address"
    label="Address line 1">
    </v-text-field>

    <v-text-field
    v-model="formData.address2"
    label="Address line 2">
    </v-text-field>

    <v-text-field
    v-model="formData.state"
    label="State / Province">
    </v-text-field>

    <v-text-field
    v-model="formData.city"
    label="City">
    </v-text-field>

    <v-text-field
    v-model="formData.zip_code"
    label="ZIP code">
    </v-text-field>

    <v-text-field
    v-model="formData.country"
    label="Country">
    </v-text-field>

    <v-text-field
    v-model="formData.phone"
    label="Address Phone number">
    </v-text-field>

  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default: function () {
        return {
          address: '',
          address2: '',
          state: '',
          city: '',
          zip_code: '',
          country: '',
          phone: ''
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    new () {
      this.formData.address = ''
      this.formData.address2 = ''
      this.formData.state = ''
      this.formData.city = ''
      this.formData.zip_code = ''
      this.formData.country = ''
      this.formData.phone = ''
    },
    edit (id) {
      var address = this.$store.state.db.addresses.addresses[id]
      this.formData.address = address.address
      this.formData.address2 = address.address2
      this.formData.state = address.state
      this.formData.city = address.city
      this.formData.zip_code = address.zip_code
      this.formData.country = address.country
      this.formData.phone = address.phone
    },
    getData () {
      return this.formData
    }
  }
}
</script>
